import React from 'react';
import { Gift } from 'lucide-react';
const BONUSES = [{
  title: 'BONUS #1: Calendario Productivo Anual',
  subtitle: '15 módulos A4 — Incluido gratis',
  description: 'Sabé qué plantar cada mes y mantené producción continua durante todo el año sin cortes.',
  image: 'https://cdn.magicpatterns.com/uploads/vUcE4mDX7HfectPv6eGB6F/ChatGPT_Image_24_feb_2026,_15_07_39.png'
}, {
  title: 'BONUS #2: Fertilizantes Naturales & Bioinsumos',
  subtitle: '15 módulos A4 — Incluido gratis',
  description: 'Nutrición real con recetas caseras, aplicación y frecuencia. Sin químicos, sin gastos innecesarios.',
  image: 'https://cdn.magicpatterns.com/uploads/1g2JeP8HNTtA4mec5Q3TkZ/ChatGPT_Image_24_feb_2026,_15_07_54.png'
}, {
  title: 'BONUS #3: Mini Invernadero Low Cost',
  subtitle: '15 módulos A4 — Incluido gratis',
  description: 'Protegé tus cultivos y producí fuera de temporada con bajo presupuesto. Paso a paso con materiales accesibles.',
  image: 'https://cdn.magicpatterns.com/uploads/kMza1fkLJ7YH8jY572FLV9/ChatGPT_Image_24_feb_2026,_15_51_19.png'
}];
export function BonusesSection() {
  return <section className="py-24 px-4 bg-zinc-900 relative overflow-hidden" data-id="element-16">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-black/20 to-transparent pointer-events-none" data-id="element-17" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <span className="inline-block bg-red-600 text-white font-bold text-xs uppercase px-3 py-1 rounded-full mb-4 animate-pulse" data-id="element-20">
            Gratis por hoy
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-21">
            Además, Llevás Estos Bonos
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-22">
          {BONUSES.map((bonus, index) => <div key={index} className="bg-black border border-zinc-800 rounded-xl overflow-hidden hover:border-zinc-700 transition-colors" data-id="element-23">
              <div className="bg-zinc-950 flex items-center justify-center p-6" data-id="element-24">
                <img src={bonus.image} alt={bonus.title} className="w-auto h-56 object-contain drop-shadow-2xl" data-id="element-25" />
              </div>
              <div className="p-6" data-id="element-26">
                <div className="flex items-center gap-2 mb-3" data-id="element-27">
                  <div className="bg-green-500 p-1.5 rounded-lg" data-id="element-28">
                    <Gift className="w-4 h-4 text-black" data-id="element-29" />
                  </div>
                  <span className="text-white font-bold text-sm tracking-wide" data-id="element-30">
                    INCLUIDO
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-31">
                  {bonus.title}
                </h3>
                <p className="text-green-500 text-sm font-semibold mb-3" data-id="element-32">
                  {bonus.subtitle}
                </p>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-33">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}